<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="view">
    <v-col class="col-2 pl-5  d-none d-md-inline">
      <v-img
          v-if="product.image_path"
          :src="'/'+product.image_path+'.64.jpg'"
          aspect-ratio="1"
          class="grey lighten-2"
      >
      </v-img>
      <v-img
          v-else
          :src="'/images/products/default.64.jpg'"
          aspect-ratio="1"
          class="grey lighten-2"
      >

      </v-img>
      <v-btn
          v-if="product.non_over_stock"
          class="ml-1 orange pa-1 caption"
          style="color: white;position: absolute;top: -10px" x-small>
        !! สินค้าไม่ผลิตเพิ่ม
      </v-btn>
    </v-col>
    <v-col class="detail offset-1 offset-md-0">
      <!--{{ product.nickcode}}-->
      <div class="nickname">
        <span v-if="product.unit_primitive === 'CTN'"
              class="red pl-1" style="color: white">
        ยกหีบ
      </span> {{ product.nickname}}

      </div>
      <div v-if="$store.state.carts.current.id" class=" text-left stock">
          <span class="float-right">
            คลัง {{$helper.number_format(product.stock_MT * product.unit_prim_rate -  product.reserve_MT)}}<span
              class="unit">{{$helper.parseUnit(product.unit_primitive)}}</span>
            /
          ราคา {{product['price_'+$store.state.carts.current.price_group]}}<span class="currency">บ.</span>
          </span>

      </div>
      <div v-else class=" text-right stock">
        <span class="float-right">
            คลัง {{$helper.number_format(product.stock_MT * product.unit_prim_rate-product.reserve_MT)}}<span
            class="unit">{{$helper.parseUnit(product.unit_primitive)}}</span>
          </span>
        <!--<span v-if="product.stock_MT>0">MT: {{ product.stock_MT}}<span class="unit">{{product.unit_single}}</span>-->
        <!--/ {{ product.price_MT}}<span class="currency">บ.</span>-->
        <!--</span>-->
        <!--<span v-if="product.stock_MT>0 && product.stock_PJ>0"> | </span>-->
        <!--<span v-if="product.stock_PJ>0">PJ: {{ product.stock_PJ}}<span class="unit">{{product.unit_single}}</span>-->
        <!--/ {{ product.price_PJ}}<span class="currency">บ.</span>-->
        <!--</span>-->


      </div>
    </v-col>
    <v-col class="col-4 col-md-3 text-right pr-5">
      <v-btn class="add-button" :class="$store.state.carts.current_item_map[product.id]?'primary':''"
             :disabled="product.non_over_stock && product.stock_MT * product.unit_prim_rate-product.reserve_MT<=0"
             @click.stop="onClickAddCart(product)">เพิ่ม
        <span v-if="$store.state.carts.current_item_map[product.id]">
              {{$store.state.carts.current_item_map[product.id].quantity}}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
  .view {
    .col {
      padding: 6px;
    }
  }

  .detail {
    font-size: 14px;
  }

  .nickname {
    height: 40px;
    overflow-y: hidden;
  }

  .stock {
    font-size: 16px;
  }

  .unit {
    font-size: 0.7em;
  }

  .percent {
    font-size: 0.7em;
  }

  .currency {
    /*display: block;*/
    /*width: 32px;*/
    /*float: right;*/
    font-size: 0.7em;
  }

  @media (max-height: 700px) {
    .add-button {
      padding: 0 4px !important;
      min-width: 10px !important;
    }
  }


</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Product} from '../../models/Product'

  @Component({
    components: {},
  })
  export default class ProductRowColumn2 extends Vue {
    @Prop() product: Product
    @Prop() onClickAddCart: Function

  }

</script>
